import {useState} from 'react';

import {useBuyerQuery, usePurchaseBuyers} from '../hooks';
import {InitiatePaymentFlow} from '../modals';
import {BuyerActionButton} from './BuyerActionButton';

export interface BuyerPaymentButtonProps {
  trustAccountId: string;
  partyId: string;
  /** Purchase to request payment for — falls back to the buyer's first purchase if omitted. */
  purchaseId?: string;
  showRequestPayment: boolean;
  onViewBuyer: () => void;
  className?: string;
}

export function BuyerPaymentButton({
  trustAccountId,
  partyId,
  purchaseId,
  showRequestPayment,
  onViewBuyer,
  className
}: BuyerPaymentButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const {data: buyer} = useBuyerQuery(trustAccountId, isOpen ? partyId : '');
  const resolvedPurchase = purchaseId
    ? buyer?.purchases.find(p => p.id === purchaseId)
    : buyer?.purchases[0];
  const {buyers: purchaseBuyers} = usePurchaseBuyers(
    trustAccountId,
    isOpen ? resolvedPurchase?.id : undefined,
    buyer?.id
  );
  const buyersForPayment = purchaseBuyers.length > 0 ? purchaseBuyers : buyer ? [buyer] : [];

  return (
    <>
      <BuyerActionButton
        showRequestPayment={showRequestPayment}
        onRequestPayment={() => setIsOpen(true)}
        onViewBuyer={onViewBuyer}
        className={className}
      />
      {buyer && (
        <InitiatePaymentFlow
          trustAccountId={trustAccountId}
          buyers={buyersForPayment}
          isOpen={isOpen}
          selectedPurchase={resolvedPurchase}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
